export enum ClinicModulesKeys {
  APPOINTMENT = 'appointment',
  APPOINTMENT_RECOMMENDATIONS = 'appointmentRecommendations',
  APPOINTMENT_REQUESTS = 'appointmentRequests',
  APPOINTMENT_WAIT_LIST = 'appointmentWaitList',
  AUTO_GENERATE_PAN = 'autoGeneratePAN',
  AUTHORIZATION_VERIFICATION = 'authorization',
  AUTHORIZATION_SUBMISSION = 'authorizationSubmission',
  AUTHORIZATION_AI = 'authorizationAi',
  BILLING = 'billing',
  CONFIRMATION = 'confirmation',
  CHARITY_CARE = 'charityCare',
  DASHBOARD_ATB = 'dashboardAtb',
  ELIGIBILITY = 'eligibility', // appointment-specific E&B
  EPISODE = 'episode',
  ESTIMATE = 'estimate',
  EXTENDED_ADDRESS = 'extendedAddress',
  FILE_WORKLISTS = 'fileWorklists',
  INTAKE = 'intake',
  INTERNAL_MESSAGING = 'internalMessaging',
  EMBEDDED_APP_MESSAGING = 'embeddedAppMessaging',
  NOTES = 'notes',
  PAYMENT = 'payment',
  PRICER = 'pricer',
  PROCEDURES_ESTIMATE = 'proceduresEstimate',
  REFERRAL = 'referral',
  RESULTS = 'results',
  SHOPPER_ESTIMATES = 'shopperEstimates',
  SURVEY = 'survey',
  TECH = 'tech',
  WORKLIST = 'worklist',
  NOT_REQUIRED_ESTIMATE_STATUS = 'notRequiredEstimateStatus',
}

export type ClinicModules = {
  [moduleKey in ClinicModulesKeys]?: boolean
}
